"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export default function Nav() {
  const router = useRouter();

  const [role, setRole] = useState("");

  useEffect(() => {
    const storedRole =
      localStorage.getItem("role") || "";

    setRole(storedRole);
  }, []);

  function logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("role");

    router.push("/login");
  }

  const links = [
    {
      href: "/",
      label: "Chat",
    },
  ];

  if (role === "admin") {
    links.push(
      {
        href: "/admin/upload",
        label: "Feltöltés",
      },
      {
        href: "/admin/documents",
        label: "Dokumentumok",
      },
      {
        href: "/admin/stats",
        label: "Statisztikák",
      },
      {
        href: "/admin/queries",
        label: "Lekérdezések",
      },
      {   
        href: "/admin/users",
        label: "Felhasználók",
      }
    );
  }

  return (
    <nav className="mb-6 rounded-3xl bg-white p-4 shadow-sm">
      <div className="mx-auto flex max-w-7xl flex-wrap gap-3">
        {links.map((link) => (
          <Link
            key={link.href}
            href={link.href}
            className="rounded-2xl bg-slate-100 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-200"
          >
            {link.label}
          </Link>
        ))}

        <div className="ml-auto flex items-center gap-3">
          <div className="rounded-2xl bg-slate-900 px-4 py-2 text-sm text-white">
            {role || "user"}
          </div>

          <button
            onClick={logout}
            className="rounded-2xl bg-red-100 px-4 py-2 text-sm font-medium text-red-700 hover:bg-red-200"
          >
            Kilépés
          </button>
        </div>
      </div>
    </nav>
  );
}
